<div *ngIf="comments.length !== 0" class="mto-comments-container">
    <lib-mto-comment *ngFor="let comment of comments" [comment]="comment"></lib-mto-comment>
</div>
<div *ngIf="comments.length === 0">
    <div style="padding-bottom: 1.5rem;" *ngFor="let comment of emptyComments">
        <lib-mto-comment [comment]="comment"></lib-mto-comment>
    </div>
</div>